import React from "react";

/**
 * BetaChip — a tiny "BETA" badge shown right next to the HEXA logo.
 * Signals to visitors and users that HEXA OS is a beta product.
 *
 * Props:
 *   - size: "sm" (default) | "xs" — controls chip height/typography
 *   - tone: "brand" (default gradient) | "outline" (transparent bg + border)
 *   - className: passthrough for margin/positioning
 */
export default function BetaChip({ size = "sm", tone = "brand", className = "", ...rest }) {
  const isXS = size === "xs";
  const isOutline = tone === "outline";
  return (
    <span
      data-testid="beta-chip"
      role="status"
      aria-label="HEXA OS Beta"
      className={`inline-flex items-center gap-1 mono uppercase tracking-[0.22em] leading-none select-none whitespace-nowrap ${className}`}
      style={{
        fontSize: isXS ? 8 : 9,
        padding: isXS ? "2px 5px" : "3px 6px",
        borderRadius: 999,
        color: isOutline ? "#c7c1ff" : "#0b0b1e",
        background: isOutline
          ? "rgba(139,92,246,0.10)"
          : "linear-gradient(120deg, #fbbf24, #f472b6, #a78bfa, #22d3ee)",
        border: `1px solid ${isOutline ? "rgba(139,92,246,0.55)" : "rgba(255,255,255,0.55)"}`,
        fontWeight: 700,
      }}
      {...rest}
    >
      <svg viewBox="0 0 24 24" width={isXS ? 7 : 8} height={isXS ? 7 : 8} aria-hidden="true">
        <polygon points="12,2 22,7 22,17 12,22 2,17 2,7" fill={isOutline ? "#a78bfa" : "#0b0b1e"} />
      </svg>
      Beta
    </span>
  );
}
